export const formatUserEmail = (email: string): string => {
  if (!email) {
    return '';
  }

  // Check if email contains 'csb.user' - return 'Automated'
  if (email.includes('csb.user')) {
    return 'Automated';
  }

  try {
    // Extract name from email (part before @)
    const emailPrefix = email.split('@')[0];

    // Split by dot and capitalize each part
    const nameParts = emailPrefix.split('.');
    const formattedName = nameParts
      .map((part) => {
        if (!part) {
          return '';
        }
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .filter(Boolean)
      .join(' ');

    return formattedName || email;
  } catch {
    return email;
  }
};
